import { queryOptions, useQuery } from '@tanstack/react-query';
import { chunk } from 'lodash-es';
import { api } from '@/api';
import { LocationsDurationParams } from '@/api/apis/mission-planner-distance';
import { missionPlannerDistanceQueryKeys } from '@/queries/mission-planner-distance/mission-planner-distance.keys';

const fetchDurations = async (data: LocationsDurationParams): Promise<Record<string, number>> => {
  if (!data.origin || !data.destinations.length) return {};

  const origin = data.origin.location;
  const destinations = data.destinations.map((d) => d.location);
  const chunks = chunk(destinations, 20);

  const durations = (
    await Promise.all(
      chunks.map(async (list) => api.missionPlannerDistance.getDurations([{ origin, destinations: list }])),
    )
  )
    .flat()
    .flatMap((res) => res.durations);

  return data.destinations.reduce<Record<string, number>>(
    (acc, item, currentIndex) => ({
      ...acc,
      [item.id]: durations[currentIndex] > 1 ? durations[currentIndex] * 1000 : durations[currentIndex],
    }),
    {},
  );
};

export const missionPlannerDistanceQueries = {
  getDistance: (data: LocationsDurationParams) =>
    queryOptions({
      queryKey: missionPlannerDistanceQueryKeys.getDistance(data),
      queryFn: () => fetchDurations(data),
      staleTime: Infinity,
      enabled: Boolean(data.origin && data.destinations.length),
    }),
};

export const useLocationsDistance = (data: LocationsDurationParams) => {
  return useQuery(missionPlannerDistanceQueries.getDistance(data));
};
